import {MarketerRepository} from '../repository/MarketerRepository';
import {UpdateMarketerProfileRequest} from '../models/UpdateMarketer';

export class UpdateMarketerProfileUseCase {
  constructor (private marketerRepository: MarketerRepository) {}

  async execute (id: number, profileData: UpdateMarketerProfileRequest): Promise<any> {
    return await this.marketerRepository.updateProfile(id, profileData);
  }
}
